import { render, staticRenderFns } from "./BaseChart.vue?vue&type=template&id=2dd0d935&scoped=true"
import script from "./BaseChart.vue?vue&type=script&lang=js"
export * from "./BaseChart.vue?vue&type=script&lang=js"
import style0 from "./BaseChart.vue?vue&type=style&index=0&id=2dd0d935&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd0d935",
  null
  
)

export default component.exports